import { render, staticRenderFns } from "./UploadBooks.vue?vue&type=template&id=388d509e&scoped=true&"
import script from "./UploadBooks.vue?vue&type=script&lang=js&"
export * from "./UploadBooks.vue?vue&type=script&lang=js&"
import style0 from "./UploadBooks.vue?vue&type=style&index=0&id=388d509e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d509e",
  null
  
)

export default component.exports